// @ts-expect-error
import VideoLayout from '../../../modules/UI/videolayout/VideoLayout';
import { OPEN_CHAT, SET_CHAT_IS_RESIZING, SET_CHAT_WIDTH, SET_USER_CHAT_WIDTH } from './actionTypes';
import { setFocusedTab } from './actions.any';
import { ChatTabs } from './constants';
import { SidePanelTabId } from '../side-panel/constants';
import { toggleSidePanelApp } from '../side-panel/actions';
export * from './actions.any';
/**
 * Displays the chat panel with the CHAT tab active.
 *
 * @param {Object} participant - The recipient for the private chat.
 * @param {Object} _disablePolls - Used on native.
 * @returns {{
 *     participant: Participant,
 *     type: OPEN_CHAT
 * }}
 */
export function openChat(participant, _disablePolls) {
    return function (dispatch) {
        dispatch(setFocusedTab(ChatTabs.CHAT));
        dispatch({
            participant,
            type: OPEN_CHAT
        });
    };
}
/**
 * Toggles display of the chat panel.
 *
 * @returns {Function}
 */
export function toggleChat() {
    return (dispatch) => {
        dispatch(toggleSidePanelApp(SidePanelTabId.CHAT));
        // Recompute the large video size whenever we toggle the chat, as it takes chat state into account.
        VideoLayout.onResize();
    };
}
/**
 * Sets the chat panel's width.
 *
 * @param {number} width - The new width of the chat panel.
 * @returns {{
 *     type: SET_CHAT_WIDTH,
 *     width: number
 * }}
 */
export function setChatWidth(width) {
    return {
        type: SET_CHAT_WIDTH,
        width
    };
}
/**
 * Sets the chat panel's width and the user preferred width.
 *
 * @param {number} width - The new width of the chat panel.
 * @returns {{
 *     type: SET_USER_CHAT_WIDTH,
 *     width: number
 * }}
 */
export function setUserChatWidth(width) {
    return {
        type: SET_USER_CHAT_WIDTH,
        width
    };
}
/**
 * Sets whether the user is resizing the chat panel or not.
 *
 * @param {boolean} resizing - Whether the user is resizing or not.
 * @returns {Object}
 */
export function setChatIsResizing(resizing) {
    return {
        type: SET_CHAT_IS_RESIZING,
        resizing
    };
}
